export * from 'markmap-common/dist/index.mjs';

export function childSelector(selector: string) {
  const scopedSelector = `:scope > ${selector}`;
  return function (this: Element) {
    try {
      return this.querySelectorAll(scopedSelector);
    } catch {
      const matches = Array.from(this.querySelectorAll(selector));
      return matches.filter((node) => node.parentElement === this);
    }
  };
}
